var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import styledMap from 'styled-map';
import { spacing } from '../../constants';
var Wrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: grid;\n  grid-template-rows: 1fr;\n  grid-auto-columns: max-content;\n  grid-auto-rows: max-content;\n  grid-auto-flow: ", ";\n  grid-gap: ", ";\n  align-items: center;\n  /*\n  NOTE: Show a scroll bar intentionally on overflow. If the number of buttons\n  overflows the container you're doing it wrong\n  */\n  overflow: auto;\n"], ["\n  display: grid;\n  grid-template-rows: 1fr;\n  grid-auto-columns: max-content;\n  grid-auto-rows: max-content;\n  grid-auto-flow: ",
    ";\n  grid-gap: ",
    ";\n  align-items: center;\n  /*\n  NOTE: Show a scroll bar intentionally on overflow. If the number of buttons\n  overflows the container you're doing it wrong\n  */\n  overflow: auto;\n"])), styledMap(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    vertical: row;\n    default: column;\n  "], ["\n    vertical: row;\n    default: column;\n  "]))), styledMap(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    extraTight: ", ";\n    tight: ", ";\n    snug: ", ";\n    loose: ", ";\n    extraLoose: ", ";\n    ultraLoose: ", ";\n    default: ", ";\n  "], ["\n    extraTight: ", ";\n    tight: ", ";\n    snug: ", ";\n    loose: ", ";\n    extraLoose: ", ";\n    ultraLoose: ", ";\n    default: ", ";\n  "])), spacing.extraTight, spacing.tight, spacing.snug, spacing.loose, spacing.extraLoose, spacing.ultraLoose, spacing.default));
export var ControlGroup = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return React.createElement(Wrapper, __assign({}, props), children);
};
ControlGroup.defaultProps = {
    vertical: undefined,
    extraTight: undefined,
    tight: undefined,
    snug: undefined,
    loose: undefined,
    extraLoose: undefined,
    ultraLoose: undefined,
    className: ''
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map